module.exports = __webpack_public_path__ + "media/shared/assets/fonts/Rubik/Rubik-SemiBold-869208702057daef053d3faf0a6618fe.ttf";